<template>
    <div class="chart-container">
        <svg ref="chart" class="chart-content" height="500" width="100%" @mousemove="onMouseMove" @mouseleave="onMouseLeave" @touchmove="onMouseMove">
            <g :transform="'translate(' + margin.left + ', ' + (margin.top) + ')'">
                <g v-for="(tick, i) in yTicks" :key="i" class="tick" :transform="'translate(0, ' + tick.y + ')'">
                    <line :x1="0" :x2="width" class="grid" :class="{thin: (tick.value * 100) % 10 != 0}"/>
                </g>
                 <g :transform="'translate(0,' + yScale(0.05) + ')'">
                    <line class="grid" :x2="width" stroke="black" stroke-width="0.5" stroke-dasharray="5,5" />
                </g>
            </g>
            <g :transform="'translate(' + margin.left + ', ' + (margin.top) + ')'">
                <circle v-for="(point, i) in surveyPoints" r="3" :class="'survey-point fill-party-' + point.party_id" :key="i" :cx="xScale(parseTime(point.date))" :cy="yScale(point.estimate)"/>
            </g>
            <g v-for="line in sortedLines" :key="line.id + 'uncertainty'" :transform="'translate(' + margin.left + ', ' + margin.top + ')'"
             class="estimate-group" :class="[line.id == highlightParty ? 'highlight' : '', 'party-' + line.id]">
                <path class="estimate-uncertainty" :d="genArea(line.points)" :class="['fill-party-' + line.id]" />
                <path class="estimate-uncertainty-upper" :d="genUpperPath(line.points)" :class="['stroke-party-' + line.id]" />
                <path class="estimate-uncertainty-lower" :d="genLowerPath(line.points)" :class="['stroke-party-' + line.id]" />
            </g>
            <g v-for="line in sortedLines" :key="line.id + 'bg'" :transform="'translate(' + margin.left + ', ' + margin.top + ')'"
             class="estimate-group" :class="[line.id == highlightParty ? 'highlight' : '', 'party-' + line.id]">
              <path class="estimate-bg" :d="genPath(line.points)"/>
            </g>
            <g v-for="line in sortedLines" :key="line.id" :transform="'translate(' + margin.left + ', ' + margin.top + ')'"
             class="estimate-group" :class="[line.id == highlightParty ? 'highlight' : '', 'party-' + line.id]">
                <path class="estimate" :d="genPath(line.points)" :class="['stroke-party-' + line.id]"/>
            </g>
            <g :transform="'translate(' + margin.left + ', ' + (margin.top + height) + ')'" text-anchor="middle">
                <g v-for="(tick, i) in xTicks" :key="i" class="tick" :transform="'translate(' + tick.x + ', 0)'">
                    <text class="label" y="9" dy="0.71em">{{ tick.text }}</text>
                    <line class="grid" y2="6"></line> 
                </g>
            </g>
            <g :transform="'translate(' + (margin.left + xScale(today)) + ', ' + margin.top + ')'">
                <line class="grid" y1="13" :y2="height" stroke="black" stroke-width="0.5" stroke-dasharray="5,5"/>
            </g>
            <g class="activeDate" :transform="'translate(' + (margin.left + xScale(parseTime(activeDate))) + ', ' + margin.top + ')'">
                <rect :width="width - xScale(parseTime(activeDate)) + 10" class="hover-overlay" :height="height"/>
                <line class="grid" y1="13" :y2="height" />
                <text class="label" text-anchor="middle" y="5">{{ formatTime(parseTime(activeDate))}}</text>
                <g v-for="note in annotations" :key="note.id">
                    <circle r="10" :class="'fill-party-' + note.id" :cy="yScale(note.y)" style="opacity: 0.5;"/>
                    <circle r="5" :class="'fill-party-' + note.id" :cy="yScale(note.y)"/>
                    <text class="fill-blue-light" :class="{highlight: (note.id == highlightParty)}" dominant-baseline="middle" :y="note.annotationY" x="15">
                        {{ note.title }}: {{ note.y | percentage(1) }}
                    </text>
                    <text class="note" :class="[(note.id == highlightParty) ? 'active' : '', mobile ? ('fill-party-' + note.id) : '']" dominant-baseline="middle" :y="note.annotationY" x="15">
                        {{ mobile ? '' : (note.title + ': ') }}{{ note.y | percentage(1) }}
                    </text>
                </g>
            </g>
            <g :transform="'translate(' + (margin.left + xScale(parseTime('2021-09-26'))) + ', ' + margin.top + ')'">
                <text text-anchor="middle" y="-10" class="note">{{ $t("other_election") }}</text>
                <line class="grid" y1="13" :y2="height" />
            </g>
            <g :transform="'translate(' + margin.left + ', ' + (margin.top) + ')'">
                <g v-for="(tick, i) in yTicks" :key="i" class="tick" :transform="'translate(0, ' + tick.y + ')'">
                    <text class="label-bg" v-if="(tick.value * 100) % 10 == 0" x="4" y="-4" text-anchor="start" dominant-baseline="text-top" >
                        {{ tick.text }}
                        {{ i >= yTicks.length - 2 ? $t("other_second_vote_proportion") : '' }}    
                    </text>
                    <text class="label" v-if="(tick.value * 100) % 10 == 0" x="4" y="-4" text-anchor="start" dominant-baseline="text-top" >
                        {{ tick.text }}
                        {{ i >= yTicks.length - 2 ? $t("other_second_vote_proportion") : '' }}    
                    </text>
                </g>
                <g :transform="'translate(0,' + yScale(0.05) + ')'">
                    <text text-anchor="start" x="4" y="-4"  dominant-baseline="text-top" class="label-bg">{{ $t("other_five_percent_hurdle") }}</text>
                    <text text-anchor="start" x="4" y="-4"  dominant-baseline="text-top" class="label">{{ $t("other_five_percent_hurdle") }}</text>
                </g>
            </g>
        </svg>
    <div v-if="mobile" class="legend-container">
      <div class="legend">
        <div v-for="item in legendItems" :key="item.id" class="legend-item" @mouseover="highlightParty = item.id">
          <div class="party-name" :class="['party-' + item.id]">{{ item.title }}</div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import * as d3 from "d3";
import { max, min, flatten, map, orderBy, sortBy, merge } from "lodash";
import * as helpers from "./helpers.js";
import { mapState } from "vuex";

export default {
    name: 'ForecastChart',
    props: ["data", "survey"],
    data () {
        return {
            domYAxis: null,
            svg: null,
            legend: null,
            parseTime: d3.isoParse,
            activeDate: '2021-09-26',
            moveTimeout: null,
            clientWidth: 600,
            highlightParty: null,
            today: new Date()
        }
    },
    computed: {
        ...mapState(["windowWidth"]),
        surveyPoints () {
            if (!this.survey) return [];

            return this.survey;
        },
        mobile() {
            return this.windowWidth < 800;
        },
        margin() {
            if (this.mobile) {
                return {top: 25, right: 60, bottom: 50, left: 30}
            } else {
                return {top: 25, right: 150, bottom: 50, left: 30};
            }
        },
        maxTime() {
            return max(flatten(map(this.data.lines, l => map(l.points, "x"))))
        },
        minTime() {
            return min(flatten(map(this.data.lines, l => map(l.points, "x"))))
        },
        maxY () {
            if (this.data.lines.length == 0) return 1;
            return max(flatten(map(this.data.lines, l => map(l.points, "y"))))
        },
        width () {
            return this.clientWidth - this.margin.left - this.margin.right;
        },
        height () {
            return 500 - this.margin.top - this.margin.bottom;
        },
        yScale () {
            return d3.scaleLinear().domain([0, this.maxY + 0.075]).range([this.height, 0]);
        },
        xScale () {
            return d3.scaleTime().domain([this.parseTime(this.minTime), this.parseTime(this.maxTime)]).range([0, this.width]);
        },
        yTicks () {
            let y = this.yScale.ticks(10);

            return map(y, o => ({y: this.yScale(o), text: o * 100 + " %", value: o}));
        },
        xTicks () {
            let nTicks = this.width / 100;
            let x = this.xScale.ticks(nTicks);

            let format = this.xScale.tickFormat(10, "%b '%y");

            return map(x, (o) => ({x: this.xScale(o), text: format(o)}));
        },
        annotationAt () {
            let index;

            if (this.activeDate == null) {
                index = this.data.lines[0].points[this.data.lines[0].points.length - 1];
            } else {
                let dist = map(this.data.lines[0].points, o => Math.abs(this.parseTime(o.x) - this.parseTime(this.activeDate)))
                let mindist = min(dist);
                index = dist.indexOf(mindist);
            }

            return index;
        },
        annotations () {
            if (this.data.lines.length == 0) return [];

            let index = this.annotationAt;

            let notes = map(this.data.lines, o => {
                let val = o.points[index];
                val.id = o.id;
                val.title = o.title;
                val.color = o.color;
                val.pointy = this.yScale(val.y);

                return val;
            })

            let annotationY = helpers.avoidCollisions(map(notes, "pointy"), 10, this.height);

            notes = merge(notes, map(annotationY, o => ({annotationY: o})));

            return notes;
        },
        sortedLines () {
            return sortBy(this.data.lines, o => o.id == this.highlightParty ? 1 : 0);
        },
        legendItems () {
            return orderBy(this.data.lines, o => o.points[o.points.length - 1].y, ["desc"]);
        },
        formatTime () {
            return d3.timeFormat(this.$t("format_date_long"))
        },
    },
    methods: {
        genPath(points) {
            let line = d3.line()
            .x(d => this.xScale(this.parseTime(d.x)))
            .y(d => this.yScale(d.y));

            return line(points);
        },
        genArea(points) {
            let area = d3.area()
            .x(d => this.xScale(this.parseTime(d.x)))
            .y0(d => this.yScale(d.lower))
            .y1(d => this.yScale(d.upper));

            return area(points);
        },
        genUpperPath(points) {
            let line = d3.line()
            .x(d => this.xScale(this.parseTime(d.x)))
            .y(d => this.yScale(d.upper));

            return line(points);
        },
        genLowerPath(points) {
            let line = d3.line()
            .x(d => this.xScale(this.parseTime(d.x)))
            .y(d => this.yScale(d.lower));

            return line(points);
        },
        lighten (color, amount) {
            return color.replace(')', ', ' + amount + ')').replace('rgb', 'rgba')
        },
        onMouseMove (event) {
            if (window.TouchEvent && event instanceof TouchEvent) event = event.touches[0];
            let pointer = d3.pointer(event, this.$refs.chart);

            let coords = [pointer[0] - this.margin.left, pointer[1] - this.margin.top];

            if (coords[0] < 0 || coords[1] < 0 || coords[1] > this.height) {
                this.activeDate = '2021-09-26';
                return;
            }

            if (this.moveTimeout == null) {
                this.moveTimeout = setTimeout(() => {
                    this.highlight(this.yScale.invert(coords[1]))
                    let date = d3.timeFormat("%Y-%m-%d")(this.xScale.invert(coords[0]));
                    this.activeDate = date > '2021-09-26' ? '2021-09-26' : date;
                    this.moveTimeout = null;
                }, 10)
            }
        },
        highlight(estimate) {
            let y = map(this.annotations, o => Math.abs(o.y - estimate));
            let index = y.indexOf(min(y));

            if (this.annotations[index]) {
                this.highlightParty = this.annotations[index].id;
            }
        },
        onMouseLeave () {
            this.activeDate = '2021-09-26';
            this.highlightParty = null;
        },
        handleResize () {
            if (this.$refs.chart) {
                this.clientWidth = this.$refs.chart.clientWidth;
            }
        },
    },
    mounted () {
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.handleResize)
    },
    watch: {
        highlightParty (val) {
            this.$emit("highlightParty", val);
        }
    }
}
</script>

<style scoped>
svg {
    touch-action: pan-y;
}
.legend {
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
}

.blink_me {
  animation: blinker 2.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>